import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spinner } from "@material-tailwind/react";
import { FaLock } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = () => {
  const { authState } = useAuth();
  const location = useLocation();

  // ⏳ While auth is initializing
  if (authState.isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <div className="relative flex items-center justify-center">
          <Spinner className="h-10 w-10 text-teal-500" />
          <FaLock className="absolute text-teal-500 h-6 w-6" />
        </div>
        <p className="mt-2 text-sm text-gray-500">Authorizing...</p>
      </div>
    );
  }

  // 🔐 If NOT authenticated → redirect
  if (!authState.accessToken) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // ✅ Authenticated → allow access
  return <Outlet />;
};

export default PrivateRoute;
